import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/css/global.scss";
import "@/assets/css/animate.scss";
import "swiper/css/swiper.css";
import utils from "@/plugins/utils";
import swiper from "@/plugins/swiper";
import axios from "@/plugins/axios";
import md5 from "@/plugins/md5";
import vueMeta from "vue-meta";

import "@/components";
import VueRouter from "vue-router";
import { PiniaVuePlugin, createPinia } from "pinia";
import VueCompositionAPI from "@vue/composition-api";
import elementUi from "./plugins/element-ui";
Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
console.log("process.env", process.env);
Vue.use(VueRouter);
Vue.use(utils);
Vue.use(swiper);
Vue.use(axios);
Vue.use(md5);
Vue.use(vueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(elementUi);

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  pinia,
  router,
}).$mount("#app");
